import React, { useState, useContext, useEffect } from 'react'
import FieldsView from '@/product/components/organisms/Template/Auction/FieldsView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'

const AuctionCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)

    const { auction_dynamicfields } = dynamicContext

    const [updatedValues, setUpdatedValues] = useState({})
    const history = useHistory()

    const [fieldValue, setFieldValue] = useState([])
    const [data, setData] = useState({
        popup: false,
        status: 'newTemplate',
        id: 0,
        projectType: 0,
    })

    useEffect(() => {
        if (props?.match?.params?.id && props?.match?.params?.status) {
            setData({
                popup: true,
                status: props?.match?.params?.status,
                id: props?.match?.params?.id,
                projectType: 0,
            })
        }
    }, [props?.match?.params?.id, props?.match?.params?.status])

    useEffect(() => {
        if (auction_dynamicfields && auction_dynamicfields.length) {
            let dynamicValueAssign = [...auction_dynamicfields]
            let filtered = dynamicValueAssign.filter(
                (data) => data.name !== 'project_id'
            )
            filtered.push({
                name: 'market_status',
                value: 'open',
                type: 'default',
                active: 1,
            })
            setFieldValue(filtered)
        }
    }, [auction_dynamicfields])

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }

    const closeFunction = () => {
        history.goBack()
    }
    return (
        <>
            <Layout>
                <FieldsView
                    fieldValue={fieldValue}
                    data={data}
                    function={closeFunction}
                    additionalFieldUpdate={additionalFieldUpdate}
                    standalone={global?.standalone ? global?.standalone : false}
                />
            </Layout>
        </>
    )
}

export default AuctionCommon
